import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { StyledBox, StyledIconButton, StyledTooltip, VerticalDivider } from 'styles/common';

import { ANSWER_TYPES, QUESTION_FORM_SOURCES } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';
import { AddCircularIcon, CheckMarkIcon } from 'constants/icons';

import { Typography5, Typography10 } from 'uiToolkit/Typography';
import { TextLabel } from 'uiToolkitV1/Typography';

const getQuestionSubHeading = ({ question: { answerType }, source }) => {
  if (source === QUESTION_FORM_SOURCES.REVIEW) {
    switch (answerType) {
      case ANSWER_TYPES.review[0]?.value:
        return 'Score';
      case ANSWER_TYPES.review[1]?.value:
        return 'Scale';
      case ANSWER_TYPES.review[2]?.value:
        return 'Dropdown';
      case ANSWER_TYPES.review[3]?.value:
        return 'Text';
      case 'MULTI_SELECT':
        return 'Multi';
      case 'SHORT_TEXT':
        return 'Short Text';
      default:
        return '';
    }
  } else {
    switch (answerType) {
      case ANSWER_TYPES.engagement[0].value:
        return 'Emoji';
      case ANSWER_TYPES.engagement[1].value:
        return 'Number';
      case ANSWER_TYPES.engagement[2].value:
        return 'Options';
      case ANSWER_TYPES.engagement[3]?.value:
        return 'Text';
      default:
        return 'None';
    }
  }
};

export const CustomTooltipComp = ({ providerToDescription }) => {
  const { PEER, MANAGER, UPWARD, SELF } = providerToDescription;
  return (
    <Box borderRadius="4px" p="8px">
      <TextLabel color="common.white">Question Variants</TextLabel>
      <Box ml={2}>
        <TextLabel color="common.white">• Self: {SELF}</TextLabel>
        <TextLabel color="common.white">• Manager: {MANAGER}</TextLabel>
        <TextLabel color="common.white">• Peer: {PEER}</TextLabel>
        <TextLabel color="common.white">• Upward: {UPWARD}</TextLabel>
      </Box>
    </Box>
  );
};

const QuestionRow = ({ question, handleAddQuestion, exclusions, source }) => {
  const subtitle = getQuestionSubHeading({ question, source });
  const { hasCustomDescription, providerToDescription } = question;

  return (
    <GridRow container justify="space-between" alignItems="center">
      <Grid item xs={8}>
        <Typography10 variant="body1" weight={500} display="inline">
          {question.description}
        </Typography10>
        <Flex>
          <StyledBox flexcontainer alignitems="center" justifycontent="flex-start">
            <Typography5 color="textSecondary" weight="normal" rightGutter={1}>
              {subtitle}
            </Typography5>
            {question.tag ? (
              <>
                <VerticalDivider height="0.5rem" />
                <Typography5 color="textSecondary" weight="normal" leftGutter={1}>
                  {question.tag.displayName}
                </Typography5>
              </>
            ) : null}
          </StyledBox>
          {hasCustomDescription && providerToDescription && (
            <>
              <Typography5 color="textSecondary" weight="bold" rightGutter={1}>
                •
              </Typography5>
              <StyledTooltip title={<CustomTooltipComp providerToDescription={providerToDescription} />}>
                <Box cursor="pointer">
                  <TextLabel
                    color="text.g2"
                    sx={{ textDecoration: 'underline', alignSelf: 'center' }}
                    _hover={{ color: 'brand.blue' }}
                  >
                    Variants applicable
                  </TextLabel>
                </Box>
              </StyledTooltip>
            </>
          )}
        </Flex>
      </Grid>
      <Grid item xs={4}>
        <StyledBox flexcontainer justifycontent="flex-end">
          {exclusions?.includes(question.id) ? (
            <CheckMarkIcon color="green" />
          ) : (
            <StyledIconButton onClick={() => handleAddQuestion(question)}>
              <AddCircularIcon color="primary" />
            </StyledIconButton>
          )}
        </StyledBox>
      </Grid>
    </GridRow>
  );
};

export default QuestionRow;

const GridRow = styled(Grid)`
  padding: 0.5rem 0.25rem;
  //   pointer: cursor;
  //   &:hover {
  //     background: ${(props) => props.theme.palette.background.blue.light.v1};
  //   }
  border-bottom: 1px solid ${getColorFromKey('lightGrey')};
`;
